import { render, staticRenderFns } from "./UserPopCard.vue?vue&type=template&id=7b729811&scoped=true&"
import script from "./UserPopCard.vue?vue&type=script&lang=js&"
export * from "./UserPopCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b729811",
  null
  
)

export default component.exports